export interface MovieItem {
  id: string;
  title: string;
  category: string;
  year: string;
  rating: number;
  image: string;
  description: string;
  tags: string[];
  updateInfo: string;
  director: string;
  actors: string[];
  region: string;
  duration: string;
  episodes: string;
  content: string;
}

export const hotMovies: MovieItem[] = [
  {
    id: "movie-1",
    title: "流浪地球3",
    category: "movie",
    year: "2026",
    rating: 9.2,
    image: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%2C%20futuristic%20space%20station%20with%20Earth%20in%20background%2C%20dramatic%20lighting%2C%20cinematic%20poster%20style%2C%20warm%20orange%20and%20dark%20tones%2C%20epic%20scale&width=400&height=560&seq=movie-poster-01&orientation=portrait",
    description: "地球面临全新危机，人类命运共同体再次集结，展开一场跨越太阳系的终极救援行动。",
    tags: ["科幻", "冒险", "灾难"],
    updateInfo: "2026-07-28 更新",
    director: "郭帆",
    actors: ["吴京", "刘德华", "李雪健"],
    region: "中国大陆",
    duration: "148分钟",
    episodes: "1",
    content: `在不远的未来，太阳急速老化膨胀，将在数百年内吞没整个太阳系。面对绝境，人类决定启动\u201C流浪地球\u201D计划，倾全球之力在地球表面建造上万座发动机和转向发动机，推动地球离开太阳系，用2500年的时间奔往4.2光年外的新家园。在这漫长的旅程中，人类团结一致，共同面对未知的挑战与危险。`
  },
  {
    id: "movie-2",
    title: "封神第二部",
    category: "movie",
    year: "2026",
    rating: 8.8,
    image: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20epic%20movie%20poster%2C%20ancient%20Chinese%20warriors%20in%20mythological%20battle%2C%20dramatic%20cinematic%20lighting%2C%20gold%20and%20crimson%20tones%2C%20epic%20scale%20composition&width=400&height=560&seq=movie-poster-02&orientation=portrait",
    description: "商周之战全面爆发，姜子牙率领众神助周伐纣，封神大战一触即发。",
    tags: ["奇幻", "古装", "神话"],
    updateInfo: "2026-08-01 更新",
    director: "乌尔善",
    actors: ["费翔", "黄渤", "于适"],
    region: "中国大陆",
    duration: "155分钟",
    episodes: "1",
    content: "商王殷寿暴虐无道，引发天谴。昆仑仙人姜子牙携封神榜下山，寻找天下共主。西伯侯姬昌之子姬发历经磨难，最终举起反商大旗。众神下凡助阵，一场决定天下命运的封神大战就此拉开帷幕。"
  },
  {
    id: "movie-3",
    title: "热辣滚烫2",
    category: "movie",
    year: "2026",
    rating: 8.5,
    image: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%2C%20warm%20vibrant%20colors%2C%20fitness%20and%20transformation%20theme%2C%20inspirational%20tone%2C%20cinematic%20poster%20with%20soft%20lighting&width=400&height=560&seq=movie-poster-03&orientation=portrait",
    description: "乐莹在拳击赛场找到新方向后，开始了一段全新的自我挑战之旅。",
    tags: ["喜剧", "励志", "运动"],
    updateInfo: "2026-07-15 更新",
    director: "贾玲",
    actors: ["贾玲", "雷佳音", "张小斐"],
    region: "中国大陆",
    duration: "132分钟",
    episodes: "1",
    content: "乐莹在经历人生低谷后，通过拳击重新找到了生活的意义。这一次，她不仅要面对赛场上的对手，更要面对内心的恐惧和社会的偏见。在教练和朋友的帮助下，她一步步突破自我，最终实现了人生的华丽蜕变。"
  },
  {
    id: "movie-4",
    title: "哪吒之魔童闹海",
    category: "movie",
    year: "2026",
    rating: 9.1,
    image: "https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20movie%20poster%2C%20mythological%20character%20with%20fire%20elements%2C%20dramatic%20red%20and%20gold%20color%20scheme%2C%20epic%20cinematic%20style&width=400&height=560&seq=movie-poster-04&orientation=portrait",
    description: "哪吒与敖丙联手对抗深海龙族，一场关于命运与选择的神话史诗。",
    tags: ["动画", "奇幻", "神话"],
    updateInfo: "2026-07-30 更新",
    director: "饺子",
    actors: ["吕艳婷", "囧森瑟夫", "瀚墨"],
    region: "中国大陆",
    duration: "142分钟",
    episodes: "1",
    content: "天劫之后，哪吒和敖丙的灵魂虽然保住，但肉身面临消散的危险。太乙真人计划用七色宝莲为二人重塑肉身，然而在此过程中却遭遇了重重困难。与此同时，深海龙族蠢蠢欲动，一场更大的危机正在逼近。哪吒与敖丙的命运将何去何从？"
  },
  {
    id: "movie-5",
    title: "长安十二时辰",
    category: "movie",
    year: "2026",
    rating: 8.7,
    image: "https://readdy.ai/api/search-image?query=Chinese%20historical%20thriller%20movie%20poster%2C%20ancient%20Tang%20dynasty%20cityscape%2C%20mysterious%20atmosphere%2C%20dark%20and%20warm%20tones%2C%20cinematic%20noir%20style&width=400&height=560&seq=movie-poster-05&orientation=portrait",
    description: "大唐天宝三年，上元节前夕，长安城陷入一场惊天阴谋之中。",
    tags: ["悬疑", "古装", "历史"],
    updateInfo: "2026-06-20 更新",
    director: "曹盾",
    actors: ["雷佳音", "易烊千玺", "周一围"],
    region: "中国大陆",
    duration: "136分钟",
    episodes: "1",
    content: "大唐天宝三年，上元节前夕，都城长安沉浸在节日的喜庆之中。然而，一伙突厥狼卫潜入长安，意图在上元节之夜制造一场巨大的灾难。死囚张小敬临危受命，必须在十二个时辰内找出狼卫的藏身之处，阻止这场惊天阴谋。"
  },
  {
    id: "movie-6",
    title: "疯狂的外星人2",
    category: "movie",
    year: "2026",
    rating: 8.3,
    image: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20comedy%20movie%20poster%2C%20alien%20and%20human%20interaction%2C%20humorous%20tone%2C%20vibrant%20colors%2C%20cinematic%20comedy%20style&width=400&height=560&seq=movie-poster-06&orientation=portrait",
    description: "外星人再次降临地球，这一次他们带着更离谱的任务而来。",
    tags: ["喜剧", "科幻", "冒险"],
    updateInfo: "2026-07-10 更新",
    director: "宁浩",
    actors: ["黄渤", "沈腾", "徐峥"],
    region: "中国大陆",
    duration: "128分钟",
    episodes: "1",
    content: `距离上一次外星人造访地球已经过去了五年。这一次，一个全新的外星种族降临地球，他们声称是来\u201C考察地球文化\u201D的。然而，当耿浩和大飞再次被卷入这场星际风波时，他们发现事情远比想象中更加离谱和疯狂。`
  }
];

export const hotTVShows: MovieItem[] = [
  {
    id: "tv-1",
    title: "庆余年2",
    category: "tv",
    year: "2026",
    rating: 9.4,
    image: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20TV%20series%20poster%2C%20ancient%20Chinese%20palace%20intrigue%2C%20elegant%20costume%20drama%2C%20warm%20golden%20tones%2C%20cinematic%20quality&width=400&height=560&seq=tv-poster-01&orientation=portrait",
    description: "范闲从北齐归来后，面对更加复杂的朝堂局势和更凶险的权力斗争。",
    tags: ["古装", "权谋", "剧情"],
    updateInfo: "更新至36集",
    director: "孙皓",
    actors: ["张若昀", "李沁", "陈道明"],
    region: "中国大陆",
    duration: "45分钟/集",
    episodes: "36/48",
    content: "范闲出使北齐归来，发现自己已经身处一个更大的棋局之中。庆帝的野心、陈萍萍的秘密、二皇子的阴谋，各方势力交织在一起。范闲必须在保护家人和坚守信念之间做出选择，同时还要应对来自暗处的致命威胁。"
  },
  {
    id: "tv-2",
    title: "大奉打更人",
    category: "tv",
    year: "2026",
    rating: 8.9,
    image: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20detective%20TV%20drama%20poster%2C%20ancient%20Chinese%20supernatural%20investigation%2C%20mysterious%20dark%20atmosphere%2C%20warm%20orange%20accents&width=400&height=560&seq=tv-poster-02&orientation=portrait",
    description: "现代警校毕业生穿越到大奉王朝，成为打更人，破获一桩桩诡异案件。",
    tags: ["奇幻", "悬疑", "古装"],
    updateInfo: "更新至28集",
    director: "邓科",
    actors: ["王鹤棣", "田曦薇", "刘奕君"],
    region: "中国大陆",
    duration: "45分钟/集",
    episodes: "28/40",
    content: "警校毕业生许七安在一次意外中穿越到了大奉王朝，成为了专门处理超自然案件的打更人。凭借现代刑侦知识和过人的洞察力，他破获了一桩桩诡异离奇的案件。然而，随着调查的深入，他发现这些案件背后隐藏着一个足以颠覆整个王朝的巨大阴谋。"
  },
  {
    id: "tv-3",
    title: "繁花",
    category: "tv",
    year: "2026",
    rating: 9.3,
    image: "https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20TV%20series%20poster%2C%201990s%20Shanghai%20cityscape%2C%20nostalgic%20warm%20lighting%2C%20elegant%20vintage%20style%2C%20cinematic%20golden%20hour&width=400&height=560&seq=tv-poster-03&orientation=portrait",
    description: "九十年代的上海，阿宝在商海沉浮中书写了一段传奇人生。",
    tags: ["剧情", "年代", "商战"],
    updateInfo: "全30集",
    director: "王家卫",
    actors: ["胡歌", "马伊琍", "唐嫣"],
    region: "中国大陆",
    duration: "50分钟/集",
    episodes: "30/30",
    content: "九十年代初的上海，改革开放的春风席卷黄浦江畔。阿宝凭借过人的商业头脑和敏锐的嗅觉，从一个默默无闻的小人物一步步走到了上海滩的风口浪尖。在股票市场、外贸生意中大展拳脚的同时，他也经历了友情与爱情的种种考验。"
  },
  {
    id: "tv-4",
    title: "三体：黑暗森林",
    category: "tv",
    year: "2026",
    rating: 9.5,
    image: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%2C%20cosmic%20space%20with%20dark%20forest%20concept%2C%20mysterious%20universe%2C%20deep%20blue%20and%20black%20tones%2C%20cinematic%20epic&width=400&height=560&seq=tv-poster-04&orientation=portrait",
    description: "面壁计划启动，四位面壁者与三体文明展开了一场跨越星际的智慧对决。",
    tags: ["科幻", "悬疑", "剧情"],
    updateInfo: "更新至18集",
    director: "杨磊",
    actors: ["张鲁一", "于和伟", "陈瑾"],
    region: "中国大陆",
    duration: "55分钟/集",
    episodes: "18/30",
    content: "面对三体文明的入侵，人类启动了面壁计划。四位面壁者被赋予了至高无上的权力，他们各自制定了对抗三体的秘密计划。罗辑，一个原本普通的学者，被选为面壁者之一。在寻找对抗三体方法的过程中，他逐渐领悟到了宇宙的黑暗森林法则。"
  },
  {
    id: "tv-5",
    title: "玫瑰的故事",
    category: "tv",
    year: "2026",
    rating: 8.6,
    image: "https://readdy.ai/api/search-image?query=Chinese%20romance%20drama%20TV%20series%20poster%2C%20elegant%20woman%20in%20modern%20city%2C%20warm%20romantic%20atmosphere%2C%20soft%20pink%20and%20gold%20tones%2C%20cinematic%20style&width=400&height=560&seq=tv-poster-05&orientation=portrait",
    description: "黄亦玫在不同人生阶段经历的爱情与成长，一段关于女性自我觉醒的故事。",
    tags: ["爱情", "都市", "剧情"],
    updateInfo: "全38集",
    director: "汪俊",
    actors: ["刘亦菲", "佟大为", "林更新"],
    region: "中国大陆",
    duration: "45分钟/集",
    episodes: "38/38",
    content: "黄亦玫出生在一个书香门第，从小在呵护中长大。在人生的不同阶段，她先后遇到了几个重要的男人，每一段感情都让她对爱情和人生有了新的理解。从懵懂少女到成熟女性，黄亦玫在经历了种种磨难后，终于找到了属于自己的幸福道路。"
  },
  {
    id: "tv-6",
    title: "猎罪图鉴2",
    category: "tv",
    year: "2026",
    rating: 9.0,
    image: "https://readdy.ai/api/search-image?query=Chinese%20crime%20investigation%20TV%20drama%20poster%2C%20forensic%20artist%20sketching%2C%20suspenseful%20dark%20atmosphere%2C%20warm%20highlight%20accents%2C%20cinematic%20noir&width=400&height=560&seq=tv-poster-06&orientation=portrait",
    description: "模拟画像师沈翊与刑警队长杜城再度联手，破解一系列高难度案件。",
    tags: ["悬疑", "犯罪", "剧情"],
    updateInfo: "更新至24集",
    director: "邢键钧",
    actors: ["檀健次", "金世佳", "张柏嘉"],
    region: "中国大陆",
    duration: "45分钟/集",
    episodes: "24/36",
    content: "北江分局的模拟画像师沈翊再次与刑警队长杜城合作，面对一系列手法更加高明的犯罪案件。沈翊凭借超凡的观察力和绘画天赋，一次次还原出犯罪嫌疑人的真实面貌。然而，一个来自过去的阴影也在逐渐逼近，威胁着所有人的安全。"
  }
];

export const hotVariety: MovieItem[] = [
  {
    id: "variety-1",
    title: "奔跑吧·特别季",
    category: "variety",
    year: "2026",
    rating: 8.7,
    image: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20outdoor%20adventure%20games%2C%20vibrant%20energetic%20atmosphere%2C%20bright%20colorful%20style%2C%20entertainment%20show&width=400&height=560&seq=variety-poster-01&orientation=portrait",
    description: "跑男团再度集结，全新挑战全新阵容，欢乐升级精彩不断。",
    tags: ["真人秀", "户外", "竞技"],
    updateInfo: "更新至10期",
    director: "姚译添",
    actors: ["李晨", "郑恺", "沙溢"],
    region: "中国大陆",
    duration: "90分钟/期",
    episodes: "10/12",
    content: "本季跑男团迎来了全新的挑战模式，每一期都将前往一个特别的地点，完成一系列令人意想不到的任务。新老成员之间的化学反应让节目笑料不断，而高难度的挑战也考验着每个人的极限。"
  },
  {
    id: "variety-2",
    title: "歌手2026",
    category: "variety",
    year: "2026",
    rating: 9.1,
    image: "https://readdy.ai/api/search-image?query=Chinese%20singing%20competition%20show%20poster%2C%20music%20stage%20performance%2C%20dramatic%20spotlight%2C%20elegant%20dark%20background%20with%20gold%20accents&width=400&height=560&seq=variety-poster-02&orientation=portrait",
    description: "华语乐坛顶级歌手同台竞技，用歌声诠释音乐的力量。",
    tags: ["音乐", "竞技", "综艺"],
    updateInfo: "更新至8期",
    director: "洪啸",
    actors: ["那英", "周深", "华晨宇"],
    region: "中国大陆",
    duration: "120分钟/期",
    episodes: "8/12",
    content: "本季歌手阵容堪称华语乐坛最强配置，新老歌手同台竞技，每一场都是视听盛宴。不仅有经典歌曲的全新演绎，更有原创作品的首次亮相。谁能最终获得歌王桂冠？让我们拭目以待。"
  },
  {
    id: "variety-3",
    title: "向往的生活·山海季",
    category: "variety",
    year: "2026",
    rating: 8.9,
    image: "https://readdy.ai/api/search-image?query=Chinese%20slow-life%20variety%20show%20poster%2C%20countryside%20farm%20with%20mountains%2C%20warm%20natural%20lighting%2C%20peaceful%20rustic%20style%2C%20cinematic%20golden%20hour&width=400&height=560&seq=variety-poster-03&orientation=portrait",
    description: "黄磊、何炅带领新老朋友们，在山海之间体验简单美好的田园生活。",
    tags: ["慢综艺", "美食", "田园"],
    updateInfo: "更新至12期",
    director: "王征宇",
    actors: ["黄磊", "何炅", "张艺兴"],
    region: "中国大陆",
    duration: "100分钟/期",
    episodes: "12/14",
    content: "这一季蘑菇屋来到了山海之间的美丽小村，依山傍海的田园风光令人心旷神怡。黄磊和何炅带领新老朋友们一起种菜、做饭、聊天，在简单的生活中寻找最纯粹的快乐。每一期都有意想不到的嘉宾到来，带来满满的惊喜与感动。"
  },
  {
    id: "variety-4",
    title: "王牌对王牌·第九季",
    category: "variety",
    year: "2026",
    rating: 8.5,
    image: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20game%20variety%20show%20poster%2C%20studio%20with%20colorful%20lights%2C%20energetic%20entertainment%20atmosphere%2C%20bright%20vibrant%20style&width=400&height=560&seq=variety-poster-04&orientation=portrait",
    description: "经典IP对决再度升级，沈腾贾玲领衔打造欢乐盛宴。",
    tags: ["喜剧", "游戏", "竞技"],
    updateInfo: "更新至15期",
    director: "吴彤",
    actors: ["沈腾", "贾玲", "华晨宇"],
    region: "中国大陆",
    duration: "90分钟/期",
    episodes: "15/16",
    content: "王牌家族再度集结，本季节目邀请了众多经典影视作品的演员阵容回归，通过一系列爆笑游戏和才艺比拼，带领观众重温那些难忘的荧幕记忆。沈腾和贾玲的组合依然是节目最大的笑点担当。"
  }
];

export const rankingMovies: MovieItem[] = [
  { ...hotMovies[3], id: "rank-1", rating: 9.6 },
  { ...hotTVShows[3], id: "rank-2", rating: 9.5 },
  { ...hotTVShows[0], id: "rank-3", rating: 9.4 },
  { ...hotTVShows[2], id: "rank-4", rating: 9.3 },
  { ...hotMovies[0], id: "rank-5", rating: 9.2 },
  { ...hotVariety[1], id: "rank-6", rating: 9.1 },
  { ...hotMovies[3], id: "rank-7", rating: 9.1 },
  { ...hotTVShows[5], id: "rank-8", rating: 9.0 },
  { ...hotTVShows[1], id: "rank-9", rating: 8.9 },
  { ...hotVariety[2], id: "rank-10", rating: 8.9 }
];

export const allContent: MovieItem[] = [
  ...hotMovies,
  ...hotTVShows,
  ...hotVariety
];

export const siteInfo = {
  name: "91影视看片app",
  description: "91影视看片app每日更新最新电影在线看、热门电视剧全集和综艺节目在线播放资源。影视排行榜实时更新，追剧看片一站式搞定，高清流畅不缓冲，热门内容一网打尽。",
  url: "https://www.91yingshi.com",
  email: "contact@91yingshi.com",
  phone: "400-888-9999",
  address: "北京市朝阳区建国路88号SOHO现代城A座",
  founded: "2019",
  socialLinks: {
    weibo: "https://weibo.com/91yingshi",
    wechat: "91影视",
    douyin: "91影视看片"
  }
};

export const aboutContent = {
  intro: "91影视看片app成立于2019年，是国内领先的在线影视内容聚合平台。我们致力于为广大影视爱好者提供最新、最全、最流畅的影视内容浏览体验。经过多年的发展，平台已积累了超过5000万的注册用户，月活跃用户突破2000万，成为中国影视行业最具影响力的在线平台之一。",
  mission: "我们的使命是让每一个热爱影视的人都能方便快捷地找到想看的内容。我们与国内多家主流视频平台建立了深度合作关系，覆盖电影、电视剧、综艺、动漫、纪录片等全品类内容资源。",
  features: [
    {
      title: "海量片库",
      desc: "收录超过10万部影视作品，涵盖电影、电视剧、综艺、动漫等全品类内容，每日实时更新，让您永远不会错过任何精彩。"
    },
    {
      title: "高清流畅",
      desc: "采用先进的视频编码技术和CDN加速网络，支持1080P/4K高清播放，智能自适应码率，确保流畅观看体验。"
    },
    {
      title: "精准推荐",
      desc: "基于大数据和AI算法的智能推荐系统，根据您的观看偏好精准推荐内容，让发现好片变得更加简单。"
    },
    {
      title: "多端同步",
      desc: "支持Web、iOS、Android、智能电视等多终端访问，观看记录和收藏列表云端同步，随时随地继续追剧。"
    }
  ],
  reviews: [
    { user: "电影爱好者小王", rating: 5, comment: "用了三年了，片源真的很全，更新也快，基本想看的都能找到，强烈推荐！" },
    { user: "追剧达人小李", rating: 5, comment: "界面简洁好用，高清画质，最重要的是没有广告干扰，观影体验一流。" },
    { user: "资深影迷老张", rating: 4, comment: "推荐算法很准，经常能发现一些冷门好片，客服响应也很快，整体很满意。" },
    { user: "综艺迷小陈", rating: 5, comment: "综艺更新速度全网最快，画质清晰流畅，还有弹幕功能，看综艺氛围感拉满。" }
  ],
  milestones: [
    { year: "2019", event: "91影视看片app正式上线，首月注册用户突破10万" },
    { year: "2020", event: "完成A轮融资，平台片库突破5万部，月活用户突破500万" },
    { year: "2021", event: "推出智能推荐系统，与多家主流视频平台达成内容合作" },
    { year: "2022", event: "注册用户突破3000万，日活用户峰值突破800万" },
    { year: "2023", event: "完成B轮融资，推出多终端适配方案，全面升级播放体验" },
    { year: "2024", event: "AI推荐系统全面升级，月活用户突破2000万，行业影响力持续攀升" }
  ],
  faqs: [
    { q: "91影视看片app是否需要付费？", a: "91影视看片app提供完全免费的影视内容浏览服务，无需任何付费即可畅享海量影视资源。我们通过广告合作和内容分成来维持平台运营。" },
    { q: "如何在多个设备上同步观看记录？", a: "您只需注册并登录账号，观看记录和收藏列表将自动云端同步。在任意设备登录同一账号即可继续上次的观看进度。" },
    { q: "平台支持哪些清晰度？", a: "我们支持标清、高清(720P)、超清(1080P)和蓝光(4K)等多种清晰度选项，系统会根据您的网络状况自动适配最佳画质，您也可以手动选择偏好的清晰度。" },
    { q: "内容更新频率是怎样的？", a: "平台内容每日实时更新，热门影视剧上线后24小时内即可在平台找到。综艺节目通常在播出当天就能更新，确保您不会错过任何精彩内容。" },
    { q: "遇到播放问题怎么办？", a: "如遇到播放卡顿或无法加载的情况，建议先切换网络环境或清除浏览器缓存。如问题持续存在，请联系我们的在线客服，我们将在第一时间为您解决。" }
  ]
};